import 'raty-js';
import 'dropzone';
import '@popperjs/core';
import 'jquery-ui-touch-punch';
import 'x-editable/dist/jqueryui-editable/js/jqueryui-editable.min';
import '@fortawesome/fontawesome-free/js/all.min';

import '../vendor/jQuery-Swipeable-List-View/jquery-listswipe.js';

// Patch for legacy plugins
$.browser = $.browser || {};
$.browser.msie = /MSIE|Trident/.test(window.navigator.userAgent);
